import { createRouter, createWebHistory } from "vue-router";
import AdminRouter from "@/Routers/AdminRouter";

const routes = [
  ...AdminRouter
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  },
});

export default router